import Vue from 'vue';
import Vuesax from 'vuesax';
import Vuebar from 'vuebar';
import VueLogger from 'vuejs-logger';
import App from './App.vue';
import router from './router/index';
import store from './store';
import LoadScript from 'vue-plugin-load-script';

//css
import 'vuesax/dist/vuesax.css'; //Vuesax styles
import 'material-icons/iconfont/material-icons.css';
import '@/assets/scss/style.scss';

//components
import VsSidebarGroup from './components/vs-sidebar-group/Sidebar-Group.vue';

Vue.config.productionTip = false;

Vue.use(Vuebar);
Vue.use(Vuesax);
Vue.use(VueLogger, {
  isEnabled: true,
  logLevel : process.env.NODE_ENV === 'production' ? 'error' : 'debug',
  stringifyArguments : false,
  showLogLevel : true,
  showMethodName : true,
  separator: '|',
  showConsoleColors: true
});
Vue.component(VsSidebarGroup.name, VsSidebarGroup);
Vue.use(LoadScript);

let $app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

export default $app;
